/**
 * Component Interactive Banner
 * 
 * @module component-interactive-banner
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-interactive-banner';

if (!customElements.get(customElements.component)) {
    class componentInteractiveBanner extends HTMLElement {

        /**
         * Interactive banner web component.
         * 
         * @constructor
         */
        constructor() {

            super();

            this.images = this.querySelectorAll('[data-image]');
            
            this.initEvents();
        }

        /**
         * Init component events.
         * 
         * @returns {undefined}
         */
        initEvents() {
            if(!this.images) return false;

            this.images.forEach((image) => {
                image.addEventListener('mouseover', (event) => {
                    this.disableAllImages();
                    image.classList.add('active');
                });
            });
        }

        /**
         * Event that disable all images
         * 
         * @returns {undefined}
         */
        disableAllImages() {
            if(!this.images) return false;

            this.images.forEach((image) => {
                image.classList.remove('active');
            });
        }

    
    }

    customElements.define(customElements.component, componentInteractiveBanner);
}